// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"OBTPopupPanel_closeButton__3VBe5","popupPanel":"OBTPopupPanel_popupPanel__1FZ7H"};